import React, { useState } from "react";
import { toast } from "sonner";
import { Check } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const REASONS: [string, string][] = [["spam", "Spam"], ["molestie", "Molestie o insulti"], ["odio", "Odio o discriminazione"], ["sessuale", "Contenuti sessuali"],
  ["pericolo", "Qualcuno potrebbe essere in pericolo"], ["falso", "Falso o ingannevole"], ["altro", "Altro"]];

export function SafetyReportDialog({ url, title, note, open, onOpenChange, onDone }: { url: string; title: string; note?: string; open: boolean; onOpenChange: (o: boolean) => void; onDone?: () => void }) {
  const [reason, setReason] = useState("");
  const [details, setDetails] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    setBusy(true);
    try {
      await api.post(url, { reason, details });
      toast.success("Segnalazione inviata. Grazie, la valuteremo.");
      setReason(""); setDetails("");
      onOpenChange(false);
      onDone?.();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="menu-panel rounded-3xl max-w-md w-[calc(100%-2rem)]" data-testid="safety-report-dialog">
        <DialogHeader><DialogTitle>{title}</DialogTitle></DialogHeader>
        {note && <p className="text-sm text-ink/66">{note}</p>}
        <div className="grid gap-2" role="radiogroup" aria-label="Motivo">
          {REASONS.map(([k, l]) => (
            <button key={k} type="button" role="radio" aria-checked={reason === k} onClick={() => setReason(k)} data-testid={`safety-reason-${k}`}
              className={`text-left px-4 py-2.5 rounded-2xl border-2 flex items-center gap-2 ${reason === k ? "border-[hsl(var(--primary))] bg-white/80 font-semibold" : "border-white/70 bg-white/35"}`}><span className="flex-1">{l}</span>{reason === k && <Check size={16} className="text-[hsl(var(--primary))]" />}</button>
          ))}
          <textarea value={details} onChange={(e) => setDetails(e.target.value)} maxLength={500} placeholder="Dettagli (facoltativo)" className="field min-h-[70px]" aria-label="Dettagli" data-testid="safety-details" />
          <button className="btn btn-primary" disabled={!reason || busy} onClick={submit} data-testid="safety-submit-btn">Invia segnalazione</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
